export default "__VITE_PUBLIC_ASSET__d3a6a23c__"